import { Component, OnInit } from '@angular/core';
import { DataChangedService, HEADLINE_TYPE } from '../data-changed.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-public',
    templateUrl: './public.component.html',
    styleUrls: ['./public.component.scss'],
    standalone: false
})
export class PublicComponent implements OnInit {
  constructor(
    private dataChangedService: DataChangedService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.dataChangedService.setHeadline({
      headline: this.translateService.instant('app.welcome'),
      type: HEADLINE_TYPE.GENERIC,
      image: null,
      subheadline: null,
    });
  }
}
